export default "__VITE_ASSET__BrCGPqEu__"